<template>
  <v-container>
    <v-row justify="center">
      <v-col>
        <div class="font-weight-bold mb-2 text-center">
          {{ faqList[actual].title }}
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <video
        autoplay
        controls
        muted
        playsinline
        :poster="require('@/assets/img/poster.jpg')"
        class="video_help align-self-center"
      >
        <source
          :src="faqList[actual].video"
          type="video/mp4"
          alt="help video"
        />
      </video>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      actual: 0,
      faqList: [
        {
          title: "¿Cómo instalar Solena Explore en iOS (iPhone)?",
          video: require("@/assets/videos/installIOS.mp4"),
        },
        {
          title: "¿Cómo iniciar sesión?",
          video: require("@/assets/videos/logIn.mp4"),
        },
        {
          title: "¿Dónde ver el detalle de una muestra?",
          video: require("@/assets/videos/sampleDetail.mp4"),
        },
        {
          title: "¿Cómo crear una entrada en bitácora sobre un área?",
          video: require("@/assets/videos/logbook.mp4"),
        },
        {
          title: "¿Cómo crear manejo agronómico en un área?",
          video: require("@/assets/videos/agronomic.mp4"),
        },
      ],
    };
  },
  created() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
    this.actual = this.$route.params.id;
  },

  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style></style>
